import { c as _c } from "react/compiler-runtime";
import { Button, VStack } from '@chakra-ui/react';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { NextLink } from '@src/components/sco/utilities/NextLink';

/** Next steps when Inbox has no human thread yet. */
export const InboxStartCtas = t0 => {
  const $ = _c(25);
  const {
    size: t1,
    includeOpportunities: t2
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const includeOpportunities = t2 === undefined ? false : t2;
  const paths = useAdvisorsPaths();
  let t3;
  if ($[0] !== includeOpportunities || $[1] !== paths.opportunities || $[2] !== size) {
    t3 = includeOpportunities && <Button asChild={true} size={size} variant="cta" width="full"><NextLink href={paths.opportunities}>View opportunities</NextLink></Button>;
    $[0] = includeOpportunities;
    $[1] = paths.opportunities;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = includeOpportunities ? "outline" : "cta";
  let t5;
  if ($[4] !== paths.directory) {
    t5 = <NextLink href={paths.directory}>Find advisors</NextLink>;
    $[4] = paths.directory;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== size || $[7] !== t4 || $[8] !== t5) {
    t6 = <Button asChild={true} size={size} variant={t4} width="full">{t5}</Button>;
    $[6] = size;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== paths.seatNew) {
    t7 = <NextLink href={paths.seatNew}>Open a board seat</NextLink>;
    $[10] = paths.seatNew;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== size || $[13] !== t7) {
    t8 = <Button asChild={true} size={size} variant="outline" width="full">{t7}</Button>;
    $[12] = size;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== paths.ask) {
    t9 = <NextLink href={paths.ask}>Ask Wil</NextLink>;
    $[15] = paths.ask;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== size || $[18] !== t9) {
    t10 = <Button asChild={true} size={size} variant="ghost" width="full">{t9}</Button>;
    $[17] = size;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t3 || $[22] !== t6 || $[23] !== t8) {
    t11 = <VStack align="stretch" gap={2} width="full">{t3}{t6}{t8}{t10}</VStack>;
    $[20] = t10;
    $[21] = t3;
    $[22] = t6;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};